import React, { useState } from 'react';
import { Modal, Button, InputNumber } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './BuyCreditsModal.scss';

const BuyCreditsModal = ({
    visible,
    onClose,
    onConfirm, 
    planData
}) => {
    const [quantities, setQuantities] = useState({});
    
    const creditItems = planData?.name != 'custom_contract_ai' ? {
        products: [
            { id: 'product_model', name: 'Simple product models', price: 125, credits: 13, subtitle: '13 credits per model' },
            // { id: 'complex_product_models', name: 'Complex product models', price: 250, credits: 25, subtitle: '25 credits per model' },
            { id: 'simple_product_variants', name: 'Simple product variants', price: 63, credits: 6, subtitle: '6 credits per model' },
            { id: 'complex_product_variants', name: 'Complex product variants', price: 125, credits: 13, subtitle: '13 credits per model' },
            { id: 'space_room_models', name: 'Space/room models', price: 200, credits: 20, subtitle: '20 credits per model' },
            { id: 'ai_models', name: 'AI models', price: 10, credits: 1, subtitle: '1 credit per model' }

        ],
        images: [
            { id: 'ai_image_4k', name: 'AI final images (4K) / AI Video', price: 42, credits: 4, subtitle: '4 credits per final 4K image / ai video. Unlimited 1K generations.', custom_description: 'final 4K image / ai video' },
            // { id: 'ai_image_1k', name: 'AI image (1K)', price: 1, credits: 4, subtitle: 'Unlimited 1K generations.' },
            { id: 'ai_final_images_4k_msp', name: 'AI final images (4K) + MSP', price: 110, credits: 12, subtitle: '12 credits per final image. Unlimited 1K generations.', custom_description: 'final 4K image' },
            { id: 'silo_images_4k', name: 'Silo images (4K)', price: 20, credits: 2, subtitle: '2 credits per set', custom_description: 'set of 4 images' },
            { id: 'lifestyle_images_2k', name: 'Lifestyle images (2K)', price: 30, credits: 3, subtitle: '3 credits per image' },
            { id: 'lifestyle_images_4k', name: 'Lifestyle images (4K)', price: 60, credits: 6, subtitle: '6 credits per image' },
            { id: 'lifestyle_images_4k_msp', name: 'Lifestyle images (4K) + MSP', price: 200, credits: 20, subtitle: '20 credits per image' },
            // { id: 'ai_model', name: 'AI Model', price: 10, credits: 20, subtitle: '5 credits per model' }

        ],
        otherAssets: [
            { id: '360_spins', name: '360 spins', price: 65, credits: 7, subtitle: '7 credits per asset' },
            { id: 'mp4_videos', name: 'MP4 videos', price: 65, credits: 7, subtitle: '7 credits per asset' },
            { id: '3d_tours', name: '3D tours', price: 65, credits: 7, subtitle: '7 credits per asset' }
        ]
    } : {
        products: [
            { id: 'ai_models', name: 'AI models', price: 10, credits: 4, subtitle: '4 credit per model' }
        ]
    };

    const handleQuantityChange = (id, value) => {
        setQuantities(prev => ({
            ...prev,
            [id]: value || 0
        }));
    };

    const calculateTotal = () => {
        let totalCredits = 0;
        let totalPrice = 0;
        
        Object.keys(quantities).forEach(id => {
            const qty = quantities[id] || 0;
            if (qty > 0) {
                // Find the item
                const allItems = planData?.name != 'custom_contract_ai' ? [...creditItems.products, ...creditItems.images, ...creditItems.otherAssets] : [...creditItems.products];
                const item = allItems.find(i => i.id === id);
                if (item) {
                    totalCredits += item.credits * qty;
                    totalPrice += item.price * qty;
                }
            }
        });
        
        return { totalCredits, totalPrice };
    };

    const { totalCredits, totalPrice } = calculateTotal();

    const renderCreditItem = (item) => {
        const quantity = quantities[item.id] || 0;
        const itemCredits = item.credits * quantity;
        const itemPrice = item.price * quantity;

        return (
            <div key={item.id} className='credit-item'>
                <div className='credit-item-left'>
                    <div className='manrope f-14 w-700 lh-22 black-085'>{item.name}</div>
                    <div className='justify-in-start align-baseline'>
                        <span className='manrope f-26 w-700 lh-40 black-085'>${item.price.toLocaleString()}</span>
                        <span className='manrope f-16 w-500 lh-40 black-085'>
                            /{item.custom_description ? item.custom_description : item.name.includes('model') ? 'model' : item.name.includes('image') ? 'image' : 'asset'}
                        </span>
                    </div>
                    <div className='manrope f-12 w-400 lh-20 black-045'>{item.subtitle}</div>
                </div>
                <div className='credit-item-right'>
                    <div className='quantity-section'>
                        <div className='manrope f-10 w-500 lh-22 black-085 mb-4'>QTY</div>
                        <InputNumber
                            min={0}
                            value={quantity}
                            onChange={(value) => handleQuantityChange(item.id, value)}
                            className='quantity-input manrope f-14 lh-22 black-085 w-400'
                        />
                    </div>
                    <div className='credits-price-section'>
                        <div className='manrope f-14 w-400 lh-22 black-085' style={{ opacity: 0.6 }}>
                            {itemCredits} credits
                        </div>
                        <div className='manrope f-14 w-500 lh-22 black-085'>
                            ${itemPrice}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Modal
            centered
            closable={false}
            maskClosable={false}
            visible={visible}
            onCancel={onClose}
            footer={null}
            className="buy-credits-modal"
            destroyOnClose={true}
            width={700}>

            <div className="buy-credits-container">
                <div className="buy-credits-header">
                    <div className="modal-close-btn" onClick={onClose}>
                        <CloseOutlined />
                    </div>
                    <div className="manrope f-20 w-500 black-085 lh-28">
                        Buy credits
                    </div>
                </div>

                <div className="buy-credits-content">
                    <div className="credit-section">
                        <div className="manrope f-14 w-700 lh-22 black-085 section-title">Products</div>
                        {creditItems.products.map(renderCreditItem)}
                    </div>

                    {planData?.name != 'custom_contract_ai' && 
                    <div className="credit-section">
                        <div className="manrope f-14 w-700 lh-22 black-085 section-title">Images</div>
                        {creditItems.images.map(renderCreditItem)}
                    </div>}

                    {planData?.name != 'custom_contract_ai' && <div className="credit-section">
                        <div className="manrope f-14 w-700 lh-22 black-085 section-title">Other Assets</div>
                        {creditItems.otherAssets.map(renderCreditItem)}
                    </div>}
                </div>

                <div className="buy-credits-footer">
                    <div className="footer-content">
                        {totalCredits > 0 && (
                            <div className="subtotal">
                                <span className="manrope f-16 w-500 lh-24 black-085">Subtotal:</span>
                                <span className="manrope f-20 w-700 lh-28 black-085">${totalPrice.toLocaleString()}</span>
                            </div>
                        )}
                        <div className="footer-actions">
                            <Button
                                className="cancel-button"
                                onClick={onClose}>
                                Cancel
                            </Button>
                            <Button
                                className="confirm-button"
                                onClick={() => {
                                    if (onConfirm) {
                                        console.log('BuyCreditsModal: Confirm clicked', { quantities, totalCredits, totalPrice });
                                        onConfirm({ quantities, totalCredits, totalPrice });
                                    } else {
                                        console.log('BuyCreditsModal: onConfirm not provided');
                                    }
                                }}
                                disabled={totalCredits === 0}>
                                {totalCredits > 0 ? `Buy ${totalCredits} credits` : 'Add credits to continue'}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default BuyCreditsModal;
